import { AppContext } from 'common/Globals'
import { useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setInternetConnectionLost } from 'store/actions/global'

export const useNetworkSatus = () => {
    const { isUserAuthed } = useContext(AppContext)
    const dispatch = useDispatch()

    useEffect(() => {
        const setNetworkStatus = () => dispatch(setInternetConnectionLost(!window.navigator.onLine))

        if (isUserAuthed) {
            setNetworkStatus()

            window.addEventListener('offline', setNetworkStatus)
            window.addEventListener('online', setNetworkStatus)
        }

        // Clear network change listeners after logout
        return () => {
            window.removeEventListener('offline', setNetworkStatus)
            window.removeEventListener('online', setNetworkStatus)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuthed])
}
